import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'app-pix-payment-key-favored-create-modal-not-found',
	templateUrl: './modal-create-not-found.component.html',
	styleUrls: ['./modal-create-not-found.component.styl'],
})
export class PixModalPaymentKeyFavoredCreateNotFoundComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<PixModalPaymentKeyFavoredCreateNotFoundComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {

	}

	ngOnInit(): void {
	}

	onClose(): void {
		this.dialogRef.close();
	}

	onConfirm(): void {
		this.dialogRef.close(true);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/payment-key/favored-create/modal-create-not-found/modal-create-not-found.component.ts